/**
 * Auth provider configuration.
 *
 * When DATA_PROVIDER is 'mongodb', use Keycloak.
 * When DATA_PROVIDER is 'firestore' (or unset), use Clerk + Firebase Auth.
 */

export type AuthProvider = 'clerk' | 'keycloak';

export function getAuthProvider(): AuthProvider {
  const dataProvider = process.env.NEXT_PUBLIC_DATA_PROVIDER ?? process.env.DATA_PROVIDER ?? 'firestore';
  return dataProvider === 'mongodb' ? 'keycloak' : 'clerk';
}

export const AUTH_PROVIDER = getAuthProvider();

export const isKeycloakAuth = AUTH_PROVIDER === 'keycloak';
export const isClerkAuth = AUTH_PROVIDER === 'clerk';

// Cookie names for each auth provider
export const KEYCLOAK_COOKIE_NAME = 'keycloak-token';
export const KEYCLOAK_REFRESH_TOKEN_COOKIE_NAME = 'keycloak-refresh-token';
export const KEYCLOAK_ID_TOKEN_COOKIE_NAME = 'keycloak-id-token';
export const FIREBASE_COOKIE_NAME = 'firebase-auth-token';

// Cookie max age: 7 days in seconds
export const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 7;

export function getAuthCookieName(): string {
  return isKeycloakAuth ? KEYCLOAK_COOKIE_NAME : FIREBASE_COOKIE_NAME;
}
